import React, {
  useEffect,
  useState,
} from 'react';
import { Interfaces, } from '../../../../config';
import { useSnackbar, } from 'notistack';
import { helpers, } from '../helpers';
import { catalogsServices, } from '../../../../services';
import { ReusableModal, } from './ReusableModal';
import { AxiosResponse, } from 'axios';

const DDLDialog = ({
  catalog,
  isOpen,
  handleClose,
}: {
  catalog: Interfaces.InputCatalogMetadata;
  isOpen: boolean;
  handleClose: () => void;
}) => {
  const { enqueueSnackbar, } = useSnackbar();
  const [value, setValue,] = useState('');
  const [loading, setLoading,] = useState(true);

  useEffect(() => {
    if (isOpen) {
      const filtered: Interfaces.Schema = helpers.extractInputSchemaBySelection(JSON.parse(JSON.stringify(catalog)));
      const cleansed = helpers.cleanseSchema(filtered);
      catalogsServices.dslPreview({
        ...catalog,
        schema: cleansed,
      })
        .then((response: AxiosResponse<{ data: string }>) => {
          setValue(response.data.data);
        })
        .catch((error) => {
          enqueueSnackbar(helpers.getErrorMessage(error), { variant: 'error', });
        })
        .finally(() => {
          setLoading(false);
        });
    }
    return () => {
      setLoading(true);
    };
  }, [isOpen,]);

  return (
    <ReusableModal
      open={isOpen}
      title={'DDL'}
      value={value}
      loading={loading}
      mode={'sql'}
      handleClose={() => handleClose()}
    />
  );
};

export { DDLDialog, };
